import {I18n} from "@kta20-core/interfaces/i-i18n";

export interface ICoreBridge {
    readonly i18n: I18n;
}

export const ICORE_BRIDGE = 'ICoreBridge';